import React from "react";
import { Container, Grid, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import NoDataPNG from "../assets/img/404pagenotfound.png";

const PageNotFound = () => {
  const navigate = useNavigate();
  const backToHome = () => {
    if (localStorage.getItem("auth")) {
      navigate("/view-profile");
    } else {
      navigate("/");
    }
  };

  return (
    <Container
      maxWidth="xl"
      disableGutters
      sx={{ mt: 11, p: 5, background: "#fff" }}
    >
      <Grid container>
        <Grid item xs={12} md={12}>
          <img
            src={NoDataPNG}
            className="pageNotFoundImg"
            alt="no data found"
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <Typography
            align="left"
            variant="h5"
            color="primary"
            sx={{ mt: 3, mb: 2, textAlign: "center" }}
          >
            OPPS! Page Not Found
          </Typography>
          <Typography
            align="left"
            variant="h6"
            color="#9e9e9e"
            sx={{ mb: 2, textAlign: "center" }}
          >
            Sorry,the page you're looking for doesn't exist.
          </Typography>

          <Button
            variant="outlined"
            color="primary"
            size="large"
            onClick={() => backToHome()}
          >
            Back To Home
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};

export default PageNotFound;
